import storageSession from 'redux-persist/lib/storage/session';
import { configureStore, Dispatch, ThunkAction } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { reducers } from './reducers';
import { RootState } from './hook';

const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const reduxStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const getStore = (): { dispatch: Dispatch; state: RootState } => {
  const state = reduxStore.getState();
  const { dispatch } = reduxStore;

  return { dispatch, state };
};

export const persistor = persistStore(reduxStore);
